type Props = {
  points: number[]
  width?: number
  height?: number
  gapIdx?: number
}

export function Sparkline({ points, width = 240, height = 56, gapIdx }: Props) {
  if (!points.length) return null
  const max = Math.max(...points)
  const min = Math.min(...points)
  const range = max - min || 1
  const stepX = width / (points.length - 1)
  const xy: [number, number][] = points.map((p, i) => [
    i * stepX,
    height - ((p - min) / range) * (height - 8) - 4,
  ])
  const path = xy
    .map(([x, y], i) => `${i === 0 ? 'M' : 'L'} ${x.toFixed(1)} ${y.toFixed(1)}`)
    .join(' ')
  const area = `${path} L ${width} ${height} L 0 ${height} Z`

  return (
    <svg viewBox={`0 0 ${width} ${height}`} className="sparkline" preserveAspectRatio="none">
      <defs>
        <linearGradient id="sparkGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F5A524" stopOpacity="0.25" />
          <stop offset="100%" stopColor="#F5A524" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill="url(#sparkGrad)" />
      <path
        d={path}
        fill="none"
        stroke="#F5A524"
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {gapIdx != null && xy[gapIdx] && (
        <circle
          cx={xy[gapIdx][0]}
          cy={xy[gapIdx][1]}
          r="3.2"
          fill="#F87171"
          stroke="#0B0D10"
          strokeWidth="1.5"
        />
      )}
    </svg>
  )
}
